function MenuBackground({ videoUrl, blurYogunluk = 8, overlayOpacity = 0.55, aktif = true }) {
  if (!aktif || !videoUrl) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
      }}
    >
      {/* Video katmanı */}
      <video
        src={videoUrl}
        autoPlay
        muted
        loop
        playsInline
        disablePictureInPicture
        preload="auto"
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          // iOS Safari için kritik
          WebkitTransform: 'translateZ(0)',
          transform: 'translateZ(0)',
        }}
      />

      {/* Blur + overlay katmanı */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backdropFilter: `blur(${blurYogunluk}px)`,
          WebkitBackdropFilter: `blur(${blurYogunluk}px)`,
          backgroundColor: `rgba(0, 0, 0, ${overlayOpacity})`,
        }}
      />
    </div>
  );
}

export default MenuBackground;